import React from 'react';
import { createUniqueKey } from '../../../utils';

function Labels(props) {
    const { xLabels = [], yLabels = [] } = props;

    return (
        <>
            <div className="Risk-return-labels Risk-return-xaxis-labels">
                {xLabels.map((item, index) => (
                    <span key={createUniqueKey(index, item)}>{item}</span>))}
            </div>
            <div className="Risk-return-labels Risk-return-yaxis-labels">
                {yLabels.map((item, index) => (
                    <span key={createUniqueKey(index, item)}>{item}</span>))}
            </div>
        </>
    );
}


export default Labels;
